import { get, post, deleteOne } from "@/modules/request";
import { AvatarDraw } from "./types";
import {
  ItemResponse,
  PageRequest,
  PageResponse,
  WriteResponse,
} from "@/types/api-types";

export async function createOneAvatarDraw(params: {
  referenceMediaId: number;
  negativePrompt: string;
  positivePrompt: string;
  style: string;
  strength: number;
  lineWeight: number;
}): Promise<WriteResponse<AvatarDraw>> {
  return post("/AvatarDrawing", params);
}

export async function getOneAvatarDraw(
  uuid: string
): Promise<ItemResponse<AvatarDraw>> {
  return get(`/AvatarDrawing/${uuid}`);
}

export async function getAvatarDrawPage(
  params: PageRequest<{
    style?: string;
  }>
): Promise<PageResponse<AvatarDraw>> {
  return get("/AvatarDrawingPage", params);
}

export async function deleteOneAvatarDraw(
  id: number
): Promise<WriteResponse<null>> {
  return deleteOne(`/AvatarDrawing/${id}`);
}
